import { render, staticRenderFns } from "./TextSecondary.vue?vue&type=template&id=7c576500&"
import script from "./TextSecondary.vue?vue&type=script&lang=js&"
export * from "./TextSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports